import { all, fork } from 'redux-saga/effects';

import watchGetConfirmation from './getConfirmation';
import watchGetOrder from './getOrder';
import watchGetOrders from './getOrders';
import watchSendPayment from './sendPayment';

function* totemSagas() {
  yield all([fork(watchGetOrders), fork(watchGetOrder), fork(watchSendPayment), fork(watchGetConfirmation)]);
}

export default totemSagas;
